import React, { ReactElement, useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import RedesignOnboardingHint from './RedesignOnboardingHint';
import useScreenSize from '../../utils/useScreenSize';
import { aiAssistantContext } from '../../state/AIAssistantContextProvider';
import { MukiBudeOnboardingStep } from '../AIAssistant/Dialog/hooks/useMukiBudeOnboarding';
import { ampliTrackMessageDisplayedEvent, MessageType } from '../../services/track.service';
import { campaign } from '../../constants';

const MeineInhalteSideNavbarHint = ({
  children,
}: {
  children: ReactElement,
}) => {
  const { t } = useTranslation();
  const { onboardingState, concludeOnboardingStep } = useContext(aiAssistantContext);
  const { isMdScreen, isLgScreen } = useScreenSize();
  const isMdOrLgScreen = isMdScreen || isLgScreen;

  const shouldShow = Boolean(
    isMdOrLgScreen
    && onboardingState?.[MukiBudeOnboardingStep.MEINE_INHALTE_HINT]?.shouldShow
  );

  const hasTrackedShowRef = useRef(false);
  useEffect(() => {
    if (shouldShow && !hasTrackedShowRef.current) {
      ampliTrackMessageDisplayedEvent(campaign.meineInhalte, MessageType.HINT, 1);
      hasTrackedShowRef.current = true;
    }
    if (!shouldShow) {
      hasTrackedShowRef.current = false;
    }
  }, [shouldShow]);

  const onClose = () => concludeOnboardingStep(MukiBudeOnboardingStep.MEINE_INHALTE_HINT);

  return (
    <RedesignOnboardingHint
      title={t('My Contents')}
      description={t(
        'All materials created with Muki are automatically saved here. '
        + 'This way you can find them again quickly anytime and continue editing.'
      )}
      open={shouldShow}
      placement='right'
      onClose={onClose}
      isNew
    >
      {children}
    </RedesignOnboardingHint>
  );
};

export default MeineInhalteSideNavbarHint;
